import React, { useEffect } from 'react'
import './order.css'
import axios from 'axios'
import { useState } from 'react'
function Order() {
    const [orders, setOrders] = useState([])
    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL+'/api/orders/orders').then((res) => {
            setOrders(res.data)
        }).catch((err) => {
            console.error(err);
        });
    }, [])
    const handleCustomerClick = (id) => {
        window.location.href = `/customer/${id}`
    }
    const handleProductClick = (id) => {
        window.location.href = `/product/${id}`
    }
  return (
    < >
    <div className="h-10 m-0 p-0 bg-slate-500 opacity-30" style={{borderRadius:'4px'}}>
          <input type="text" className=" m-2" style={{borderRadius: '4px'}} placeholder="Search"/>
        </div>
    <div className=" overflow-auto rounded">
    <h1 className="text-2xl font-semibold text-gray-900 mt-3 ml-3">Sales Order List</h1>
    <table className=" divide-gray-200 h-5/6 m-2 ">
  <thead className="bg-gray-150">
    <tr>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Order ID
      </th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Cust ID
        </th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Prod ID
        </th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Price X Quantity
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
            order value price ( INR )
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
            Order Method
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
            Payment Method
        </th>
        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
            Payment Status
        </th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Order Date
      </th> 
      
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
        Deliveried Date
        </th>

        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border">
            Status
        </th>
    </tr>
  </thead>
  <tbody className="bg-white divide-gray-200">
    {
        orders.map((order,index)=>{
            return(
                <tr key={order.orderId} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.orderId}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-blue-800"><button onClick={()=> handleCustomerClick(order.customerId)}>{order.customerId}</button></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-blue-800"><button onClick={()=> handleProductClick(order.productId)}>{order.productId}</button></div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.price} X {order.quantity}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.totalPrice}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.orderMethod}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.paymentMethod}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.paymentStatus?
                        <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">Completed</span>
                        :
                        <span className="inline-flex rounded-full bg-red-100 px-2 text-xs font-semibold leading-5 text-red-800">Pending</span>
                        }
                        </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.orderDate}</div>
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.deliveryDate}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border">
                        <div className="text-sm text-gray-900">{order.status}</div>
                    </td>
                </tr>
            )
        })
    }
    
  </tbody>
</table>
</div>
    </>
  )
}

export default Order